/* eslint-disable no-return-await */

import { AxiosResponse } from 'axios';
import { API_URLS } from '../../../constants/urls/api-urls';
import { getData } from '../../../utils/fetch-api-util';

export const getProductsInCategoryRepository = async (params?: any) => {
  const response: AxiosResponse<any> = await getData(
    API_URLS.ECOM_GET_PRODUCT_ALL,
    params,
    undefined,
    process.env.REACT_APP_ECOM_CLIENT_ID,
  );

  return response.data;
};
